import React from 'react';

import Select from 'react-select';

import approvalStatusGeneral from '@/data/approvalStatusGeneral';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectApprovalStatusGeneral: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={approvalStatusGeneral.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={approvalStatusGeneral}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectApprovalStatusGeneral;
